<template>
  <div>
    <p>已退款金额：{{refund.sum}}元 &nbsp;&nbsp;&nbsp;&nbsp;待退款金额：{{refund.wait}}元</p>
    <Table stripe :columns="columns" :data="refund.data"></Table>
  </div>
</template>

<script>
export default {
  props: {
    refund: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      columns: [
        {
          title: '创建时间',
          width: 200,
          align: 'center',
          key: 'createdAt'
        },
        {
          title: '退款单号',
          width: 200,
          align: 'center',
          key: 'refundNo'
        },
        {
          title: '退款金额',
          width: 200,
          align: 'center',
          key: 'refundAmout',
          render: (h, param) => {
            return h('div', {}, `¥ ${param.row.refundAmout}`)
          }
        },
        {
          title: '退款类型',
          width: 200,
          align: 'center',
          key: 'refundType'
        },
        {
          title: '退款原因',
          width: 200,
          align: 'center',
          render: (h, param) => {
            return h('div', [
              h('p', {}, param.row.createType),
              h('p', {}, param.row.refundReason),
              h('p', {}, `操作人：${param.row.createBy}`)
            ])
          }
        },
        {
          title: '退款状态',
          width: 200,
          align: 'center',
          key: 'stat'
        },
        {
          title: '退款时间',
          width: 200,
          align: 'center',
          render: (h, param) => {
            return h('span', {}, param.row.stat === '已退款' ? param.row.updatedAt : '-')
          }
        }
      ]
    }
  },
  filters: {
    toPrice(price) {
      if (isNaN(price)) {
        return '¥ 0.00';
      }
      return '¥ '+(price/100).toFixed(2);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/order/order_detail/refund-detail.vue